import React, { FC } from "react";

import { FormattedMessage } from "../FormattedMessage/FormattedMessage";
import messages from "./messages";

export interface FormattedTimeUnitProps {
  unit: "hour" | "day" | "week" | "month" | "quarter" | "year";
  format?: "long" | "short";
}

const HOURLY_MESSAGES = {
  short: {
    hour: messages.short.hour,
    day: messages.short.day,
    week: messages.short.week,
    month: messages.short.month,
    quarter: messages.short.quarter,
    year: messages.short.year,
  },
  long: {
    hour: messages.long.hour,
    day: messages.long.day,
    week: messages.long.week,
    month: messages.long.month,
    quarter: messages.long.quarter,
    year: messages.long.year,
  },
};

export const FormattedTimeUnit: FC<FormattedTimeUnitProps> = ({
  unit = "hour",
  format = "long",
}) => {
  const message = HOURLY_MESSAGES[format][unit];
  return <FormattedMessage {...message} />;
};
